export default "__VITE_ASSET__zVsQ8NZo__"